"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var canary_1 = require("./canary");
function setCanaryHeader(headers) {
    headers.set('X-OWA-CANARY', canary_1.getOwaCanaryCookie());
    // The debug cookie doesn't exist in retail
    var owaCanaryDebugCookie = canary_1.getOwaCanaryDebugCookie();
    if (owaCanaryDebugCookie) {
        headers.set('X-OWA-CANARY-DEBUG', owaCanaryDebugCookie);
    }
}
exports.default = setCanaryHeader;
